import React from 'react';
import Tetris from './components/Tetris'

function App() {
  return (
    <div>
      <Tetris />
    </div>
  );
}

export default App;
